import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Payments/Table";
import Navbar from "../../Components/Navbar";
import ChangePasswordModal from "../../Components/Admin/ChangePasswordModal";
import { ToastContainer, toast } from "react-toastify";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
  SmallBtn,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import NotFoundModel from "../../Components/NotFoundModel";
import DeleteModel from "../../Components/Customers/DeleteModel";
import { useSelector } from "react-redux";
import { ForUs } from "../../Config";
import EditUserModel from "../../Components/Customers/EditUserModel";
import SingleEntry from "../../Components/Customers/SingleEntry";
import { MdAdd } from "react-icons/md";
import { HiUpload } from "react-icons/hi";
import ViewModel from "../../Components/Payments/ViewModel";
import moment from "moment";
import { useTranslation } from "react-i18next";

const Payments = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const gTypeOfGame = useSelector((state) => state?.GamesDataReducer?.games);
  const { days } = useParams();
  // console.log(days);
  const [changePasswordModel, setChangePasswordModel] = useState(false);
  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [searchType, setSearchType] = useState("0");

  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("all");
  const [openViewModel, setOpenViewModel] = useState(false);

  const [editUser, setEditUser] = useState(false);

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(days ? 0 : 60, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  //const isLoadingFetch = "";
  //const error = "";
  //const refetch = "";
  //const isRefetching = "";

  // ----- Getting Initial Data ------
  const fetchFunction = async () => {
    const body = new FormData();
    // body.append("filter", filter);
    // body.append("filterValue", filterValue);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("paymentStatus", 0);
    body.append("status", 0);
    body.append("filter", filter);
    body.append("filterValue", filterValue);
    return await axios.post(`${Config.apiUrl}/listPayments`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  // const { isLoadingFetch, error, data, refetch, isRefetchingFetch } = useQuery(
  //   "customerList",
  //   fetchFunction
  // );

  const getPaymentsSuccess = (res) => {
    if (res.data.status == "NOK") error = true;
  };

  const getPaymentsError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getPaymentsMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getPaymentsSuccess,
    onError: getPaymentsError,
  });

  useEffect(() => {
    getPaymentsMutate(searchType);
  }, []);

  /*********** Export Function *********** */

  const getPaymentsExportApi = async () => {
    const body = new FormData();
    body.append("filter", filter);
    body.append("filterValue", filterValue);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("paymentStatus", 0);
    body.append("status", 0);
    return await axios.post(`${Config.apiUrl}/exportpayments`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const submitHandlerForExport = (values) => {
    getPaymentsExport();
  };

  const GetExportDataSuccess = (data) => {
    window.open(data.data.path, "_blank");
  };

  const GetExportDataError = (data) => console.log("error", data);

  const { isLoading: InitialLoadingForExport, mutate: getPaymentsExport } =
    useMutation(getPaymentsExportApi, {
      onSuccess: GetExportDataSuccess,
      onError: GetExportDataError,
    });

  /*********** End Export Function *********** */

  const initialValues = {
    billId: "",
    filterVal: "",
    startDate: moment(new Date()).subtract((days ? 0 : 60), "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
    // startDate: moment(new Date()).subtract(7, "days").format("YYYY-MM-DD"),
    // endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getPaymentsMutate(searchType);
  };

  const submitHandlerTypeSearch = (values) => {
    {
      setFilterValue(values.filter);
    }
    // console.log(values);
    // console.log(filter);
    // console.log(filterValue);
    getPaymentsMutate(values);
    //refetch();
  };

  const TypeFilters = ({
    initialValues,
    submitHandler,
    InitialLoading,
    user,
    submitHandlerForExport,
    t,
  }) => {
    return (
      <Formik initialValues={initialValues} onSubmit={submitHandler}>
        <Form>
          <FilterContainer>
            <InputGroup className="max-w-xs" style={{ flexBasis: "content" }}>
              <Label htmlFor="filter">{t("Type")}</Label>

              <Select
                autoComplete="off"
                className="w-36 pl-2 bg-transparent text-sm p-0 border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  //searchHandler(e.target.value);
                }}
              >
                <MenuItem value="all">ALL</MenuItem>
                <MenuItem value="0">Registration</MenuItem>
                <MenuItem value="6">Annual Fees</MenuItem>
                <MenuItem value="1">Constitution</MenuItem>
                <MenuItem value="2">Article</MenuItem>
                <MenuItem value="3">Name</MenuItem>
                <MenuItem value="4">Address</MenuItem>
                <MenuItem value="5">Lost certificate</MenuItem>

                {/* <MenuItem value="phone">By Mobile</MenuItem> */}
              </Select>
            </InputGroup>
            {/* <InputGroup className="max-w-xs">
              <Label htmlFor="filterVal">Value</Label>
              <FieldWrapper className="h-10">
                <Field
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  class="ml-1"
                  //  onSubmit={(e) => {
                  //   setFilterValue(e.target.value);
                  //   //searchHandler(e.target.value);
                  // }}
                />
              </FieldWrapper>
            </InputGroup> */}

            {/* <InputGroup className="max-w-xs">
                <Label htmlFor="endDate">End Date:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field type="date" name="endDate" id="endDate" class="ml-1" />
                </FieldWrapper>
              </InputGroup> */}

            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Search")}
            </ApplyBtn>

            {/* <p
              className="p-3 border-b border-gray-100 text-sm text-white px-5 bg-cyan-600 hover:bg-cyan-700 rounded-md py-2.5 text-sm"
              disabled={InitialLoading}
              type="button"
              onClick={submitHandlerForExport}
            >
              Export
            </p> */}
          </FilterContainer>
        </Form>
      </Formik>
    );
  };

  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Payments")}</Title>
              <Underline />
            </div>
          </div>
          {/* <BoxTitle onClick={() => navigate(-1)}>
            <img src={Images.Arrow} alt="arrow" className="w-2" />
            <p>Admin</p>
          </BoxTitle> */}
          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              submitHandlerForExport={submitHandlerForExport}
              user={user}
              t={t}
            />

            <TypeFilters
              submitHandler={submitHandlerTypeSearch}
              initialValues={initialValues}
              InitialLoading={isLoading}
              user={user}
              submitHandlerForExport={submitHandlerForExport}
              t={t}
            />
            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>

          {openViewModel && (
            <ViewModel
              setOpenViewModel={setOpenViewModel}
              selectedItem={selectedData}
              gTypeOfGame={gTypeOfGame}
            />
          )}

          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={error ? [] : data?.data?.data}
                setOpenDeleteModel={setOpenDeleteModel}
                setSelectedData={setSelectedData}
                setEditUser={setEditUser}
                setOpenViewModel={setOpenViewModel}
                setChangePasswordModel={setChangePasswordModel}
              />
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
          {error && !isLoading && <NotFoundModel />}
        </BoxContainer>
      </Page>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  submitHandlerForExport,
  t,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs">
            <Label htmlFor="startDate">{t("Start_Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="startDate" id="startDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <InputGroup className="max-w-xs">
            <Label htmlFor="endDate">{t("End_Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <ApplyBtn disabled={InitialLoading} type="submit">
            {t("Date_filter")}
          </ApplyBtn>

          <p
            className="p-3 border-b border-gray-100 text-sm text-white px-5 bg-cyan-600 hover:bg-cyan-700 rounded-md py-2.5 text-sm"
            disabled={InitialLoading}
            type="button"
            onClick={submitHandlerForExport}
          >
            {t("Export")}
          </p>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const Uploader = ({ setOpenUploadModel }) => {
  return (
    <UploadWrapper>
      <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <MdAdd className="text-white w-5 h-5" /> <p>Add User</p>
      </Button>
      {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
      </Button> */}
    </UploadWrapper>
  );
};

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-cyan-600 hover:bg-cyan-700  py-2.5 text-sm`;

const FilterContainer = tw.div`
grid grid-cols-2 w-full max-w-xl gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;
const ExportWrapper = tw.div` w-full cursor-pointer absolute top-10 right-0 bg-white shadow-md  rounded-md z-50`;

export default Payments;
